import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import Vertical from "./Vertical";
import Content from "./Content";

// styles
import { convertPxToRem } from "frontend/components/helpers";

const Row2Styled = styled.div`
    position: relative;
    margin-top: ${({ $marginTop }) => convertPxToRem($marginTop)};
    height: ${({ $height }) => convertPxToRem($height)};
    overflow: ${({ $isVisible }) => ($isVisible ? "visible" : "hidden")};
`;

// component
export const Row2 = () => {
    const {
        animation: { overflow },
        header: { secondRowHeight, secondRowMarginTop }
    } = useSiteHeader();
    return (
        <Row2Styled
            $isVisible={overflow.isVisible}
            $height={secondRowHeight}
            $marginTop={secondRowMarginTop}
        >
            <Vertical>
                <Content />
            </Vertical>
        </Row2Styled>
    );
};

export default Row2;
